<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            :color="color"
            title="Subscriptions"
            text="A table of Subscriptions"
          >
            <v-spacer/>
            <v-layout>
              <v-spacer/>
              <v-flex
                xs12
                sm6
                md6>
                <v-text-field
                  v-model="search"
                  :loading="loading"
                  append-icon="search"
                  label="Search"
                  hide-details/>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="clientList"
              :disable-initial-sort="true"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              item-key="name"
              class="elevation-1"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="props.expanded = !props.expanded">
                  <td>
                    {{ props.item.name }}
                  </td>

                  <td>
                    {{ props.item.contract_start }}
                  </td>
                  <td>{{ props.item.contract_end }}</td>

                  <td>{{ new Date(props.item.created_at).toLocaleString() }}</td>
                  <td> <v-icon v-if="props.item.active">check</v-icon></td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-container>
                  <v-layout>
                    <v-spacer/>
                    <v-flex
                      xs12
                      sm6
                      md6>
                      <v-text-field
                        v-model="subsearch"
                        append-icon="search"
                        label="Search"
                        hide-details/>
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="subheaders"
                    :items="props.item.subscriptions"
                    :disable-initial-sort="true"
                    :hide-default-footer="true"
                    :search="subsearch"
                    class="elevation-1"
                    hide-actions
                    disable-pagination
                    compact
                  >
                    <!-- change table header background and text color(or other properties) -->
                    <template
                      slot="headerCell"
                      slot-scope="{ header }"
                    >
                      <span
                        class="subheading font-weight-light text-general text--darken-3"
                        v-text="header.text"
                      />
                    </template>
                    <template v-slot:items="props">
                      <tr @click="editItem(props.item)">
                        <td>
                          {{ props.item.start_date }}
                        </td>
                        <td>
                          ${{ props.item.total_price }}
                        </td>

                        <td>
                          {{ props.item.commission_rate }}% (${{ props.item.total_price * props.item.commission_rate / 100 }})
                        </td>
                        <td>
                          {{ new Date(props.item.created_at).toLocaleString() }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  <v-dialog
                    v-model="dialog"
                    max-width="768px">
                    <v-card>
                      <v-card-text>
                        <v-container grid-list-md >
                          <v-layout wrap>
                            <v-flex
                              xs12
                              sm6
                              md6>
                              <v-text-field
                                v-model="editedSubscription.commission_rate"
                                disabled
                                type="number"
                                label="Commission(%)" />
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              md6>
                              <v-text-field
                                v-model="mycut"
                                disabled
                                type="number"
                                label="My Cut($)" />
                            </v-flex>
                          </v-layout>

                          <h4>Subscription Information</h4>

                          <v-layout wrap>
                            <v-flex
                              xs12
                              sm6
                              md6>
                              <v-select
                                v-model="editedSubscription.client_id"
                                :items="clientList"
                                disabled
                                item-text="name"
                                item-value="id"
                                label="Client"
                                dense
                              />
                            </v-flex>
                            <table style="font-size: 10px;width:100%; table-layout: fixed; border-collapse: collapse">

                              <template v-for="item in editedSubscription.items">
                                <tr @click="editItem(item)">
                                  <td
                                    v-if="item.service"
                                    style="font-size: 12px;width:60%;text-align: left">
                                    {{ item.service.name }}
                                  </td>
                                  <td style="width:30%; white-space: pre-wrap; text-align: right;">
                                    Quantity: {{ item.quantity }}
                                  </td>
                                  <td
                                    v-if="item.service"
                                    rowspan="2"
                                    style="width:10%;white-space: pre-wrap; text-align: right;">
                                    ${{ (item.service.price- (item.discount_type == 'amount'?item.discount: item.discount/100*item.service.price)) * item.quantity }}
                                  </td>
                                </tr>
                                <tr
                                  style="border-bottom: 1px solid gray"
                                  @click="editItem(item)">
                                  <td
                                    v-if="item.service"
                                    style="text-align: left;">
                                    {{ item.service.description }}
                                  </td>
                                  <td
                                    v-if="item.service"
                                    style="text-align: right;">
                                    Unit Price: <br >
                                    ${{ item.service.price }} <span v-if="item.discount !=0"> - ${{ item.discount_type == 'amount'?item.discount: item.discount/100*item.service.price }}  = ${{ item.service.price - (item.discount_type == 'amount'?item.discount: item.discount/100*item.service.price) }} </span>
                                  </td>
                                </tr>
                              </template>
                              <tr>
                                <td
                                  colspan="3"
                                  style="text-align: right;white-space: pre-wrap;">
                                  Total: ${{ editedSubscription.total_price || 0 }}
                                </td>

                              </tr>
                              <tr>
                                <td
                                  colspan="3"
                                  style="text-align: right;white-space: pre-wrap;">
                                  Commission: ${{ editedSubscription.total_price? editedSubscription.total_price * editedSubscription.commission_rate / 100: 0 }}
                                </td>
                              </tr>
                            </table>
                            <v-flex
                              xs12
                              sm6
                              md6>
                              <v-menu
                                v-model="startCalendar"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                disabled
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="editedSubscription.start_date"
                                    v-bind="attrs"
                                    disabled
                                    label="Contract Start"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                  />
                                </template>
                                <v-date-picker
                                  v-model="editedSubscription.start_date"
                                  @input="startCalendar = false"
                                />
                              </v-menu>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              md6>
                              <v-menu
                                v-model="endCalendar"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                disabled
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="editedSubscription.end_date"
                                    v-bind="attrs"
                                    disabled
                                    label="Contract End"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                  />
                                </template>
                                <v-date-picker
                                  v-model="editedSubscription.end_date"
                                  @input="endCalendar = false"
                                />
                              </v-menu>
                            </v-flex>

                          </v-layout>

                        </v-container>

                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-container>
              </template>
            </v-data-table>

            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'

  export default {
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {},
    clientList: [],
    serviceList: [],
    client: {},
    affiliate: {},
    service: {},
    loading: true,

    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    search: '',
    subsearch: '',
    editedSubscription: {
      id: '',
      quantity: 1,
      discount: 0,
      commission_rate: 10,
      start_date: '',
      end_date: '',
      service_id: '',
      client_id: '',
      created_at: '',
        discount_type: 'amount'
    },
    subheaders: [
    {
      text: 'Start',
      align: 'left',
      value: 'start_date'
    },
    {
      text: 'Total',
      align: 'left',
      value: 'total_price'
    },
      {
        text: 'Commission',
        align: 'left',
        value: 'commission_rate'
      },
    {
      text: 'Created At',
      align: 'left',
      value: 'created_at'
    }
  ],
    headers: [
      {
        text: 'Client',
        align: 'left',
        value: 'name'
      },
      {
        text: 'Start',
        align: 'left',
        value: 'contract_start'
      },
      {
        text: 'End',
        align: 'left',
        value: 'contract_end'
      },
      {
        text: 'Created At',
        align: 'left',
        value: 'created_at'
      },
      {
        text: 'Active',
        align: 'left',
        value: 'active'
      }
    ],
    defaultItem: {
      id: '',
      affiliate_id: '',
      number: 'AUTO ASSIGN',
      address: '',
      phone: '',
      contract_start: '',
      contract_end: '',
      created_at: '',
      active: true,
      contact_name: '',
      email: '',
      commission_rate: '',
      subscriptions: null,
        discount_type: 'amount'
    }
  }),

  computed: {
    ...mapState('app', ['color']),
    total: function () {
      return (this.price - parseFloat(this.editedSubscription.discount)) * parseInt(this.editedSubscription.quantity)
    },
    mycut: function () {
      return this.editedSubscription.total_price * this.editedSubscription.commission_rate / 100
    },
    price: function () {
      for (var i = 0; i < this.serviceList.length; i++) {
        if (this.serviceList[i].id == this.editedSubscription.service_id) {
          return parseFloat(this.serviceList[i].price)
        }
      }
    },
      unitPrice () {
          if (this.editedSubscription.discount_type == 'amount') {
              return this.price - parseFloat(this.editedSubscription.discount)
          } else {
              return this.price * (100 - parseFloat(this.editedSubscription.discount)) / 100
          }
      },
      total () {
          return this.unitPrice * parseInt(this.editedSubscription.quantity)
      }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }

  },
  // called when page is created before dom
  created () {
    this.index()
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
  },

  methods: {
    editItem (item, dbox = true) {
      var sub = Object.assign({}, item)
      self = this
      for (var i = 0; i < sub.items.length; i++) {
        for (var j = 0; j < self.serviceList.length; j++) {
          if (sub.items[i].service_id == self.serviceList[j].id) {
            sub.items[i].service = self.serviceList[j]
            break
          }
        }
      }
      this.editedSubscription = sub
      this.dialog = dbox
    },
    mapService () {
      for (var i = 0; i < this.clientList.length; i++) {
        for (var j = 0; j < this.clientList[i].subscriptions.length; j++) {
          for (var k = 0; k < this.serviceList.length; k++) {
            if (this.serviceList[k].id === this.clientList[i].subscriptions[j].service_id) {
              this.clientList[i].subscriptions[j].service_name = this.serviceList[k].name
            }
          }
        }
      }
    },
    index () {
      this.loading = true
      let self = this
      axios.get('/api/clients/subscriptions')
              .then(response => {
                self.clientList = response.data
                self.loading = false
                self.getServices()
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },
    getServices () {
      let self = this
      axios.get('/api/services')
              .then(response => {
                self.serviceList = response.data
                self.mapService()
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },

    close () {
      this.dialog = false
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
